<template>
  <div id="dashboard">
    <div class="block-content-full">
      <div class="dataTables_wrapper dt-bootstrap4 no-footer">
        <div class="row mb-1">
          <div class="col-12 col-md-4 text-center text-md-left">
            <pageSize @changePageSize="changePageSize"></pageSize>
          </div>
          <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
            <div class="dt-buttons">
              <button
                class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                tabindex="0"
                aria-controls="DataTables_Table_1"
                data-clipboard-text
                @click="copy()"
                type="button"
                id="copybtn"
              >
                <span>复制</span>
              </button>
              <button
                class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                @click="exportCSV()"
                type="button"
              >
                <span>导出</span>
              </button>
              <button
                class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                @click="print()"
              >
                <span>打印</span>
              </button>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center text-md-right">
            <div class="dataTables_filter">
              <label>
                <input
                  type="search"
                  class="form-control"
                  placeholder="搜索"
                  v-model="key"
                  @keyup.enter="search()"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive">
              <section ref="print">
                <p class="show-on-print print-title">用户意见反馈</p>
                <p
                  class="show-on-print print-subheading"
                >{{ '时间范围： ' + duration.startDate + ' 至 ' + this.duration.endDate }}</p>
                <table
                  id="feedBackList"
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th
                        class="text-center sorting"
                        style="width: 60px; min-width:60px"
                        @click="getList('ID',$event)"
                      >#</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:175px;"
                        @click="getList('COMPANY_NAME',$event)"
                      >来源</th>
                      <th
                        class="text-left sorting d-md-table-cell"
                        style="min-width:100px;"
                        @click="getList('CELL_NAME',$event)"
                      >小区名称</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:95px;"
                        @click="getList('QUESTTYPE',$event)"
                      >问题类型</th>
                      <th
                        class="text-left sorting"
                        style="width: 180px;min-width: 180px;"
                        @click="getList('QUESTION',$event)"
                      >问题描述</th>
                      <th
                        class="text-left sorting"
                        style="min-width:100px;"
                        @click="getList('USER_ID',$event)"
                      >用户ID</th>
                      <th
                        class="text-left sorting"
                        style="min-width:100px;"
                        @click="getList('PHONE',$event)"
                      >手机号码</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:175px;"
                        @click="getList('CREATETIME',$event)"
                      >提交时间</th>
                      <th
                        class="text-center d-xl-table-cell sorting"
                        style="width: 100px; min-width:100px"
                        @click="getList('STATUS',$event)"
                      >状态</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:180px;"
                        @click="getList('TAKE_TIME',$event)"
                      >耗时</th>
                      <th
                        class="text-center d-xl-table-cell no-print"
                        style="width: 100px; min-width:100px"
                        v-if="editBtn"
                      >操作</th>
                    </tr>
                  </thead>
                  <tbody v-if="feedBacks.length">
                    <tr v-for="(item, i) in feedBacks" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-left d-xl-table-cell">{{ item.COMPANY_NAME }}</td>
                      <td class="text-left d-md-table-cell">{{ item.CELL_NAME }}</td>
                      <td
                        class="text-left d-xl-table-cell"
                        style="min-width:80px;"
                      >{{ showType(item.QUESTTYPE) }}</td>
                      <td class="text-left d-xl-table-cell">
                        <div class="text-over" style="width:180px">{{ item.QUESTION }}</div>
                      </td>
                      <td class="text-left">{{ item.USER_ID }}</td>
                      <td class="text-left">{{ item.PHONE }}</td>
                      <td class="text-left d-xl-table-cell">{{ item.CREATETIME }}</td>
                      <td class="text-center d-xl-table-cell">
                        <li class="fa fa-exclamation-circle text-danger"></li>
                      </td>
                      <td class="text-left d-xl-table-cell">{{ item.TAKE_TIME }} </td>
                      <td class="text-center no-print" v-if="editBtn">
                        <div class="btn-group">
                          <button
                            v-if="editBtn"
                            type="button"
                            class="btn btn-primary js-tooltip-enabled"
                            title="处理客诉"
                            data-original-title="Edit"
                            data-toggle="modal"
                            @click="create(item)"
                          >
                            <i class="fa fa fa-tasks"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="11">查无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
            <div class="dataTables_info" role="status" aria-live="polite">
              页数
              <strong>{{ page }}</strong> /
              <strong>{{ totalPage }}</strong>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 text-center text-md-right">
            <div class="dataTables_paginate paging_full_numbers">
              <el-pagination
                v-if="feedBacks && feedBacks.length"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                :small="isMobile"
                :pager-count="pagerCount"
                :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                :total="total"
                background
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modal-default-normal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">处理客诉</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <!-- <div class="form-group">
                <label class="col-sm-12 control-label">用户ID</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    v-model="modalData.userId"
                    disabled
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">小区名称</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="modalData.cellName" disabled />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label for="cell-nature" class="col-sm-12 control-label">问题类型</label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    id="cell-nature"
                    name="cell-nature"
                    v-model="modalData.quesType"
                    disabled
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in answer"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label">问题描述</label>
                <div class="col-sm-12">
                  <textarea
                    class="js-maxlength form-control js-maxlength-enabled"
                    rows="5"
                    maxlength="100"
                    data-always-show="true"
                    disabled
                    v-model="modalData.question"
                  ></textarea>
                </div>
              </div>-->
              <!-- <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">手机号码</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="11"
                    v-model="modalData.phone"
                    disabled
                  />
                </div>
              </div>-->
              <!-- <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">提交时间</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="11"
                    v-model="createTime"
                    disabled
                  />
                </div>
              </div>-->
              <div class="form-group">
                <label for="cell-auth-type" class="col-sm-12 control-label">
                  处理状态
                  <span class="input-required">*</span>
                </label>
                <!-- <div class="col-sm-12">
                  <select
                    class="form-control"
                    id="cell-auth-type"
                    name="cell-auth-type"
                    v-model="modalData.state"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in answerStatus"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>-->
                <div style="padding-left: 14px;">
                  <div
                    class="custom-control custom-radio custom-control-inline custom-control-primary"
                    style="margin-right: 0;width: 50%;"
                  >
                    <input
                      type="radio"
                      class="custom-control-input"
                      id="example-radios-inline"
                      name="example-radios-inline"
                    />
                    <label
                      class="custom-control-label"
                      style="font-weight:400"
                      for="example-radios-inline"
                    >已处理</label>
                  </div>

                  <div
                    class="custom-control custom-radio custom-control-inline custom-control-primary"
                  >
                    <input
                      type="radio"
                      class="custom-control-input"
                      id="example-radios-inline1"
                      name="example-radios-inline"
                    />
                    <label
                      class="custom-control-label"
                      style="font-weight:400"
                      for="example-radios-inline1"
                    >暂不处理</label>
                  </div>
                </div>
                <!-- <div class="form-check form-check-inline" style="padding-left: 14px;">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="example-radios-inline"
                    name="example-radios-inline"
                    value="option1"
                    checked
                  />
                  <label
                    class="form-check-label"
                    for="example-radios-inline1"
                    style="font-weight:400"
                  >已处理</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="example-radios-inline1"
                    name="example-radios-inline"
                    value="option2"
                  />
                  <label
                    class="form-check-label"
                    for="example-radios-inline2"
                    style="font-weight:400"
                  >暂不处理</label>
                </div> -->
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  处理意见
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <textarea
                    class="js-maxlength form-control js-maxlength-enabled"
                    rows="5"
                    maxlength="100"
                    placeholder="请输入处理方案"
                    data-always-show="true"
                    v-model="modalData.answer"
                  ></textarea>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-sm btn-primary btn-sm-h" @click="submit()">保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../../Util.js";
import screenTime from "../../../../components/screenTime";
import pageSize from "../../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      feedBacks: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      modalData: {
        cellName: "",
        userId: "",
        phone: "",
        quesType: "",
        answer: "",
        status: "",
        question: "",
        id: ""
      },
      that: "",
      createTime: "",
      answerStatus: [
        {
          value: "0",
          label: "已处理"
        },
        // {
        //   value: "1",
        //   label: "未处理"
        // },
        {
          value: "2",
          label: "暂不处理"
        }
      ],
      answer: [
        {
          value: "1",
          label: "充电问题"
        },
        {
          value: "2",
          label: "费用问题"
        },
        {
          value: "3",
          label: "其他问题"
        }
      ],
      clipboard: null,
      sorting: "",
      orderBy: false,
      editBtn: Util.isHavePerm("adviceAndFeedback/editUserAdviceAndFeedback")
    };
  },
  components: {
    screenTime,
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },

    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    }
  },
  mounted() {
    this.that = this;
    this.getList();
    this.copy();
    // setTimeout(() => {
    //   $('#feedBackList').DataTable({
    //     scrollX: true,
    //     searching: false,//搜索
    //     info: false,
    //     scrollCollapse: true,
    //     paging: false,
    //     fixedColumns: {
    //         leftColumns: 0,
    //         rightColumns: 1
    //     },
    //     drawCallback: function(){
    //         //重绘的回调执行
    //     }
    // } );
    // }, 1000);
  },
  methods: {
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    changePage(val) {
      this.page = val;
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/Carport/Feedback/${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}&STATUS=1`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.feedBacks = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${Util.searchURL}/Carport/Feedback/${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}&STATUS=1`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[0].innerText;
      var btn = document.getElementById("copybtn");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    search() {
      this.page = 1;
      this.getList();
    },
    create(val) {
      jQuery("#modal-default-normal").modal("show");

      $("#example-radios-inline").prop("checked", false);
      $("#example-radios-inline1").prop("checked", false);
      this.modalData = {
        cellName: val.CELL_NAME,
        userId: val.USER_ID,
        phone: val.PHONE,
        quesType: val.QUESTTYPE,
        answer: val.ANSWER,
        status: val.STATUS,
        question: val.QUESTION,
        id: val.ID,
        state: val.STATUS_NUM == 1 ? "" : val.STATUS_NUM
      };
      this.createTime = val.CREATETIME;
    },
    submit() {
      if ($("#example-radios-inline")[0].checked) {
        this.modalData.state = 0;
      } else if ($("#example-radios-inline1")[0].checked) {
        this.modalData.state = 2;
      } else {
        this.modalData.state = "";
      }
      let d = {
        id: this.modalData.id,
        answer: this.modalData.answer,
        status: this.modalData.state
      };
      this.$http
        .post(
          `${Util.operateURL}/adviceAndFeedback/editUserAdviceAndFeedback`,
          d
        )
        .then(
          res => {
            if (res.data.code == 200) {
              jQuery("#modal-default-normal").modal("hide");
              Util.message("succ", res.data.desc);
              this.getList();
              this.$parent.$parent.$refs.slideBar.getMenu();
            } else {
              Util.message("err", res.data.desc);
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    showType(str) {
      if (str == "1") {
        return "充电问题";
      } else if (str == "2") {
        return "费用问题";
      } else {
        return "其他问题";
      }
    }
  }
};
</script>
<style lang="less">
.table tr td {
  .green {
    color: #82b54b !important;
  }
  .yellow {
    color: #ffb119 !important;
  }
}
</style>